import React from "react";
import { fmtFila, Variacion } from "./kpi";

export function TablaComparativa({ comp }) {
  const yoy = !!comp.anio_anterior;
  return (
    <div className="card p-6 mb-6 overflow-x-auto" data-testid="cuadro-comparativa">
      <div className="mb-4">
        <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Comparativa mensual</div>
        <h3 className="font-display text-xl font-bold">
          {comp.actual} frente a {comp.anterior || "—"}{yoy ? ` y ${comp.anio_anterior}` : ""}{comp.meses_media_rango ? ` · media de ${comp.meses_media_rango}` : ""}
        </h3>
      </div>
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="text-[10px] uppercase tracking-wider text-slate-500 border-b border-slate-200">
            <th className="text-left py-2">Indicador</th>
            <th className="text-right">{comp.actual}</th>
            <th className="text-right">{comp.anterior || "Mes anterior"}</th>
            <th className="text-right">Var.</th>
            {yoy && <th className="text-right" data-testid="cuadro-col-anio">{comp.anio_anterior}</th>}
            {yoy && <th className="text-right">Var.</th>}
            <th className="text-right" title={comp.meses_media_rango || ""}>Media {comp.meses_media} {comp.meses_media === 1 ? "mes completo" : "meses completos"}</th>
          </tr>
        </thead>
        <tbody>
          {comp.filas.map((f) => (
            <tr key={f.key} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`cuadro-fila-${f.key}`}>
              <td className="py-2 font-medium">{f.label}</td>
              <td className="text-right font-mono font-semibold">{fmtFila(f, f.actual)}</td>
              <td className="text-right font-mono text-slate-500">{fmtFila(f, f.anterior)}</td>
              <td className="text-right text-xs"><Variacion v={f.var_anterior} unit={f.unit} inverso={f.inverso} /></td>
              {yoy && <td className="text-right font-mono text-slate-500">{fmtFila(f, f.anio_anterior)}</td>}
              {yoy && <td className="text-right text-xs"><Variacion v={f.var_anio} unit={f.unit} inverso={f.inverso} /></td>}
              <td className="text-right font-mono text-slate-500">{fmtFila(f, f.media_12m)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
